import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";
import TourStepContent from "../../wrapper";

const actionTexts = [
	"image: bauhaus",
	"\nimage: bauhaus colors",
	"background: bauhaus\n|\nbackground: third\nLets Talk About\n  color: second\nsupertitle:Bauhaus\n  color: second\n  align:center\n ",
];

const split: StepType[] = [
	{
		selector: ".author-root",
		position: "center",
		content: () => <TourStepContent description={() => <strong>{text.tourSteps.splitTitle}</strong>} />,
		action: () => {
			const toggleShareButton = document.querySelector<HTMLElement>(
				'[data-testid="share-panel-toggle"]',
			);
			// Only click if the button is found and is visible
			if (toggleShareButton && toggleShareButton.offsetParent !== null) {
				toggleShareButton.click();
			}
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent description={() => text.tourSteps.splitRearrangeImages} />
		),
		action: () => {
			fireClearCodeEvent();
			const prefill = `${actionTexts[0]}\n${actionTexts[1]}`;
			typeSomeText({ text: "", prefill });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						Type the <span className="qp-tour-modifier">|</span> {text.tourSteps.splitTypePipe}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const t = `${actionTexts[0]}\n|${actionTexts[1]}`;
			typeSomeText({ text: t });
		},
	},
	{
		selector: ".cm-split-page-line.cm-line",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						The <span className="qp-tour-modifier">|</span> {text.tourSteps.splitPipeLeftRight}
					</span>
				)}
			/>
		),
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent description={() => text.tourSteps.splitSetBackground} />
		),
		action: () => {
			fireClearCodeEvent();
			const t = actionTexts[2];
			typeSomeText({ text: t });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						We simply type <span className="qp-tour-keyword">background:</span> {text.tourSteps.splitTypeBackground}
					</span>
				)}
			/>
		),
	},
];

export default split;
